import React from 'react';

import {AuthorizationsRequestsList} from 'presentation/pages/private/authorizations/pages';

export const MakeAuthorizationsRequestsList: React.FC = () => <AuthorizationsRequestsList />;
